export default class Dropdown {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.dropdown'), el => {
			new Dropdown(el);
		});
	}

	classes = {
		dropdown: 'dropdown',
		get visible() {
			return this.dropdown + '--is-visible'
		},
		get link() {
			return this.dropdown + '-link'
		}
	}

	constructor(element) {
		this.element = element;
		this.isVisible = false;
		let linkNodesArray = Array.from(document.querySelectorAll('.' + this.classes.link));

		linkNodesArray.forEach(el => {
			el.addEventListener('click', e => {
				e.preventDefault();
				e.stopPropagation();

				this.element = document.querySelector('[data-for="' + el.href.split('#')[1] + '"');
				this[this.isVisible ? 'hide' : 'show']();
			});
		});

		window.addEventListener('click', (e) => {
			let isInside = e.target.classList.contains(this.classes.dropdown) || !!e.target.closest('.' + this.classes.dropdown);

			if (!isInside) {
				this.hide();
			}
		})
	}

	show() {
		this.element.classList.add(this.classes.visible)
		this.isVisible = true;
	}

	hide() {
		this.isVisible = false;
		let dropdownNodesArray = Array.from(document.querySelectorAll('.' + this.classes.dropdown));
		dropdownNodesArray.forEach(el => {
			el.classList.remove(this.classes.visible)
		});
	}
}
